<template>
    <div class="info-edit">
        <!-- 头部 -->
        <head-bar title="退回货款" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <router-link to="/">
                        <i class="head-home-icon"></i>
                    </router-link>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <div class="main_content">
            <!-- 第一步 -->
            <div
                class="step_recharge_container"
                v-show="currentStep == stepMap.STEP_BANK"
            >
                <div class="marked_words">
                    <p>提交申请后，财务将在3个工作日处理退回货款</p>
                </div>
                <div class="bank_info">
                    <div class="caption_text">
                        <span>收款信息</span>
                    </div>
                    <div class="bank_form">
                        <van-field
                            :label-width="'65px'"
                            label="公司名称"
                            :value="walletInfo.companyName"
                            readonly
                        />
                        <van-field
                            :label-width="'65px'"
                            label="*开户银行"
                            v-model="applyForm.depositBank"
                            placeholder="请输入开户银行"
                        />
                        <van-field
                            :label-width="'65px'"
                            label="*银行卡号"
                            v-model="applyForm.bankAccount"
                            placeholder="请输入银行卡号"
                        />
                    </div>
                </div>
                <div class="money_info">
                    <div class="caption_text">
                        <span>退回金额</span>
                    </div>
                    <div class="money_form">
                        <van-field
                            :autofocus="true"
                            :label-width="'65px'"
                            label="*退回金额"
                            v-model="applyForm.tradeAmount"
                            type="text"
                            placeholder="请输入退回金额"
                        >
                            <template #button>
                                <div
                                    class="extract_amount_button"
                                    @click="setTradeAmount"
                                >
                                    <span>退回全部货款</span>
                                </div>
                            </template>
                        </van-field>
                    </div>
                </div>
                <div class="button_group">
                    <div
                        class="button_item margin_top_40"
                        @click="nextToPasswordStep"
                    >
                        <span>下一步</span>
                    </div>
                    <div
                        class="button_item skip_button margin_top_20"
                        @click="goToBack"
                    >
                        <span>返回</span>
                    </div>
                </div>
            </div>
            <!-- 第一步 -->
            <!-- 第二步 -->
            <div
                class="step_password_container"
                v-show="currentStep == stepMap.STEP_PASSWORD"
            >
                <div class="marked_words">
                    <p>请输入6位数字密码</p>
                </div>
                <div class="password_form">
                    <van-field
                        label="*确认密码："
                        v-model="applyForm.password"
                        type="password"
                        placeholder="请输入密码"
                        maxlength="6"
                    />
                </div>
                <div class="button_group">
                    <div
                        class="button_item margin_top_40"
                        @click="confirmRefund"
                    >
                        <span>确认</span>
                    </div>
                    <div
                        class="button_item skip_button margin_top_20"
                        @click="prveStep"
                    >
                        <span>返回</span>
                    </div>
                </div>
            </div>
            <!-- 第二步 -->
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import md5 from "md5";
import { Field, Button, Switch, Cell, Dialog } from "vant";
import HeadBar from "@/components/HeadBar";
import {
    isEmpty,
    isPositiveNumber,
    isFloat,
    isBankNumber,
    isWalletPassword,
} from "@/utils/validation";

Vue.use(Field);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(Dialog);

const STEP_BANK = "step_back";

const STEP_PASSWORD = "step_password";

export default {
    components: { HeadBar },
    data() {
        return {
            /* 表单数据 */
            applyForm: {
                depositBank: "", //开户银行
                bankAccount: "", //银行账号
                tradeAmount: "",
                password: "",
            },
            /* 钱包数据 */
            walletInfo: {
                companyName: "",
                totalBalance: 0,
            },
            isLoda: false,
            currentStep: STEP_BANK,
            stepMap: {
                STEP_BANK,
                STEP_PASSWORD,
            },
        };
    },
    computed: {},
    created() {
        this.getWalletInfo();
    },
    methods: {
        /**
         * @description 获取用户钱包信息
         */
        getWalletInfo() {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            const url = this.$api.userApi.queryWalletInfo;
            this.$axios
                .post(url, {})
                .then((res) => {
                    let { data: walletInfo = {} } = res;
                    this.walletInfo = walletInfo;
                })
                .catch(() => {
                    this.goToBack();
                })
                .finally(() => {
                    this.$toast.clear();
                });
        },
        nextToPasswordStep() {
            let { totalBalance = 0 } = this.walletInfo;
            let { depositBank, bankAccount, tradeAmount } = this.applyForm;

            if (!isBankNumber(bankAccount)) {
                this.$toast("请输入正确银行卡号");
                return false;
            }

            if (isEmpty(depositBank)) {
                this.$toast("请输入正确开户银行");
                return false;
            }

            if (
                (isPositiveNumber(tradeAmount) || isFloat(tradeAmount)) &&
                tradeAmount > 0 &&
                tradeAmount <= totalBalance
            ) {
                this.currentStep = STEP_PASSWORD;
            } else {
                this.$toast("请输入正确的退回金额,支持两位小数");
                return false;
            }
        },
        confirmRefund() {
            let { password } = this.applyForm;
            if (!isWalletPassword(password)) {
                this.$toast("请输入6位数字密码");
                return false;
            }
            if (this.isLoda) return;
            const vlidatePasswordURL = this.$api.userApi.validateWalletPassword;
            let _this = this;
            let walletPassword = md5(password);
            this.$axios
                .post(vlidatePasswordURL, {
                    context: {
                        walletPassword: walletPassword,
                    },
                })
                .then(() => {
                    let { walletId } = _this.walletInfo;
                    let {
                        depositBank,
                        bankAccount,
                        tradeAmount,
                    } = _this.applyForm;
                    let request = {
                        walletId: walletId,
                        depositBank: depositBank,
                        bankAccount: bankAccount,
                        tradeAmount: tradeAmount,
                        walletPassword: walletPassword,
                    };
                    const returnWalletCashURL =
                        _this.$api.userApi.returnWalletCash;
                    _this.$axios
                        .post(returnWalletCashURL, {
                            context: {
                                ...request,
                            },
                        })
                        .then(() => {
                            _this.goToBack();
                        })
                        .catch(({ msg }) => {
                            if (!isEmpty(msg)) {
                                _this.$toast(msg);
                            }
                        })
                        .finally(() => {
                            _this.isLoda = false;
                        });
                })
                .catch(({ msg }) => {
                    if (!isEmpty(msg)) {
                        _this.$toast(msg);
                    }
                    _this.isLoda = false;
                });
            // let { walletId } = this.walletInfo;
            // if (isEmpty(walletId)) return;
            // let { payAmount } = this.applyForm;
            // let isPassAmount = payAmount > 0;
            // isPositiveNumber(payAmount) || isFloat(payAmount);
            // if (!isPassAmount) {
            //     this.$toast("请输入正确的充值金额");
            //     return;
            // }
            // if (this.isLoda) return;
            // let context = {
            //     walletId: walletId,
            //     tradeAmount: payAmount,
            // };
            // this.isLoda = true;
            // this.$toast.loading({
            //     message: "数据加载中...",
            //     duration: 0,
            // });
            // const url = this.$api.userApi.walletRecharge;
        },
        prveStep() {
            this.currentStep = STEP_BANK;
        },
        goToBack() {
            this.$router.replace({
                path: "/user/wallet",
            });
        },
        setTradeAmount() {
            let { totalBalance = 0 } = this.walletInfo;
            this.applyForm.tradeAmount = totalBalance;
        },
    },
};
</script>

<style lang="less" scoped>
.info-edit {
    .head-right-slot {
        height: 100%;
        text-align: right;
        padding-right: 20px;

        i {
            *display: inline;
            display: inline-block;
            zoom: 1;
            width: 60px;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: center;
            margin: 0 10px;

            &.head-search-icon {
                background-image: url(../../../public/images/head/head-search-icon.png);
            }

            &.head-home-icon {
                background-image: url(../../../public/images/head/head-home-icon.png);
            }
        }
    }

    .extract_amount_button {
        width: 200px;
        height: 40px;
        border-radius: 38px;
        border: 1px solid #dedede;
        font-size: 24px;
        line-height: 40px;
        text-align: center;
        color: #333333;
    }

    .main_content {
        padding-top: 90px;
        .marked_words {
            height: 70px;
            background-color: #faf8d9;
            font-size: 28px;
            line-height: 70px;
            font-weight: 400;
            color: #ff5500;
            text-align: center;
        }
        .caption_text {
            padding: 0 30px;
            height: 100px;
            background-color: #fff;
            font-size: 32px;
            line-height: 100px;
            color: #333;
        }
        .button_group {
            width: 750px;
            .button_item {
                margin: 0 auto;
                width: 690px;
                height: 70px;
                background-color: #4bc227;
                border-radius: 36px;
                font-size: 28px;
                line-height: 70px;
                color: #fff;
                text-align: center;
                &.margin_top_40 {
                    margin-top: 40px;
                }

                &.margin_top_20 {
                    margin-top: 20px;
                }

                &.skip_button {
                    background-color: #96eb7c;
                }
            }
        }

        .step_recharge_container {
            width: 750px;
            .payment_info,
            .money_info {
                margin: 20px 0 0 0;
            }
        }

        .step_password_container {
            width: 750px;
        }
    }
}
</style>
